import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditDisplayConfig = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Display Config'
      fields={fields}
      apiPath={`admin/display_configs/${props.params.displayConfigId}`}
      successRedirectPath='/write-now/display_configs'
      buildMenuItems={menuItems}
    />
  )
}

export default EditDisplayConfig
